import { Component } from '@angular/core';

@Component({
  selector: 'app-price-main',
  templateUrl: './price-main.component.html',
  styleUrls: ['./price-main.component.css']
})
export class PriceMainComponent {
  english:boolean=true;
  hindi:boolean=false;
  ngOnInit(): void {
    const storeVal = localStorage.getItem('selectedValue');
    if (storeVal == 'english') {
      this.english = true;
      this.hindi = false;
    }
    if (storeVal == 'hindi') {

      this.english = false;
      this.hindi = true;
    }

  }
}
